<template>
  <v-container>
    <div style="width: 100%;overflow-x: hidden;display: flex;flex-direction: column-reverse;">
      <div v-for="(object,i) in payments" :key="object.payment._id" style="margin: 10px">
        <FactoringView v-if="object.type==='factoring' " :i-factoring="object.payment" :show="object.payment._id === byppay" :invoice="currentInvoice" :amount="listOutstanding[i]" @fetch="fetch" />
        <CollateralView v-if="object.type==='collateral'" :collateral="object.payment" />
      </div>
      <div v-if="currentInvoice && currentInvoice.relatedFactorings.length === 0" style="margin: 10px; text-align: center; width: 100%;">
        {{ $t('ByppayList.No bypay has yet been initiated with this invoice.') }}
      </div>
    </div>
  </v-container>
</template>

<script>



import FactoringView from "@/views/Factoring";
import CollateralView from "components/CollateralView";
import ApiRepository from "@/repositories/ApiRepository";


export default {
    name: "ByppayList",
    components: { FactoringView, CollateralView},
    props: {
    },
    data () {
        return {
            collaterals: null,
            payments: [],
            listOutstanding: [],
            currentInvoice: null,
            actualAmount: 0,
            byppay: '',
        };
    },
    created () {
        if (this.$route.query && this.$route.query.invoiceId) {
            this.fetch(this.$route.query.invoiceId);
        }
        if (this.$route.query.byppay) {
            this.byppay = this.$route.query.byppay;
        }

    },
    methods: {
        fetch (invoiceId) {
            ApiRepository.getInvoiceById(invoiceId)
                .then((res) => {
                    this.currentInvoice = res.data.invoice;
                    this.actualAmount = this.currentInvoice.amount;
                    this.calculateOutstanding();

                    ApiRepository.getCollateralsByFactoringId(invoiceId).then((res) => {
                        this.collaterals = res.data.collaterals;
                        for ( const factoring of this.currentInvoice.relatedFactorings ) {
                            this.payments.push({type: 'factoring', payment: factoring});

                        }

                        for ( const collateral of this.collaterals ) {
                            this.payments.push({type: 'collateral', payment: collateral});
                        }
                        this.payments = this.payments.sort((a, b) => (
                            a.type  > b.type ? 1 : -1)
                        );
                    }).catch((err) => {
                        console.log(err);
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        calculateOutstanding () {
            if (this.currentInvoice && this.currentInvoice.relatedFactorings) {
                for (const elem of  this.currentInvoice.relatedFactorings) {
                    if (elem.status === -1 || elem.status === -2) { this.listOutstanding.push(-1); } else {
                        this.listOutstanding.push(this.actualAmount - elem.compensatedPayerAmount);
                        this.actualAmount = this.actualAmount - elem.compensatedPayerAmount;
                    }
                }
            }
        },
    }
};
</script>

<style scoped>

</style>
